import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from "primereact/checkbox";

import Card from "../../../../Base/Components/Card/Card";
import { getLabel } from "../../../../Base/Services/Language/LanguageService";
import { baseLang } from "../../../../Base/Lang/BaseLang";
import { ConfigContext } from "../../../../Base/Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../../Base/Services/Config/ConfigService";
import { toastShow } from "../../../../Base/Services/ToastService";

import { chageEstadoVacantes, chageEstadoVacantesDetalles, EliminarVacanteDetalles, FirmarVacante, getDetallesVacantes, getVacantesConFirmas } from "../../../../API/RRHH/Vacantes/VacantesRequests";
import { getAutorizaciones } from "../../../../API/Compras/Autorizaciones/AutorizacionesRequest";
import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";

import VacantesCRUD from "./VacantesCRUD";
import FormatoVacante from "./FormatoVacante";
import { TabPanel, TabView } from "primereact/tabview";
import DetallesVacantesCRUD from "./DetallesVacantesCRUD";
import CandidatosCRUD from "../Maestros/CandidatosCRUD";


const VacantesScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedDetalles, setSelectedDetalles] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogDetalles, setShowDialogDetalles] = useState(false);
  const [data, setData] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const [Autorizaciones, setAutorizaciones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [estados2, setEstados2] = useState([]);
  const [dialogFormato, setDialogFormato] = useState(false);
  const [idsPermisos, setIdsPermisos] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [dialogCandidato, setDialogCandidato] = useState(false);
  const [aspirante, setAspirante] = useState(false);

  const [firmarIngenieria, setFirmarIngenieria] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(57) ); //IdPermisoGeneral 15
  const [firmarFinanzas, setFirmarFinanzas] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(58) ); //IdPermisoGeneral 16
  const [firmarRRHH, setFirmarRRHH] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(59) ); //IdPermisoGeneral 17
  const [firmarDirectorGeneral, setFirmarDirectorGeneral] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(60) ); //IdPermisoGeneral 18
  const [firmarDirectorArea, setFirmarDirectorArea] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(61) ); //IdPermisoGeneral 19
  const [firmarGerenteArea, setFirmarGerenteArea] = useState( userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(62) ); //IdPermisoGeneral 20

  const getInfo = async () => {
    setLoading(true);

    const vacantesTempo = await getVacantesConFirmas();
    setData(vacantesTempo);

    const detallesTempo = await getDetallesVacantes()
    setDetalles(detallesTempo)
    
    const estadosTempo = await getEstadosCategory("Vacantes");
    setEstados(estadosTempo.filter((e) => e.IdStatus === 81));

    const estadosTempo2 = await getEstadosCategory("Detalles Vacantes");
    setEstados2(estadosTempo2);

    const autorizacionesTempo = await getAutorizaciones();
    let AutorizacionesFiltradas = autorizacionesTempo.filter((e) => e.IdTipo === 43)
    setAutorizaciones(AutorizacionesFiltradas);

    let Ids = AutorizacionesFiltradas.map((item) => item?.IdPermisoGeneral);
    setIdsPermisos(Ids)

    setLoading(false);
  };

  const agregarFirmas = async ( event, data, IdPermisoGeneral, NombrePermiso ) => {
    const dataToSend = data.map((item) => {
      return {
        IdVacante: item?.IdVacante,
        IdPermisoGeneral: IdPermisoGeneral,
        Autorizo: !item[NombrePermiso],
        IdUsuarioAutorizo: userAuth?.IdUser,
      };
    });

    confirmDialog({
      message: `¿Está seguro que desea autorizar ${data.length} ${data.length > 1 ? "vacantes" : "vacante" }?`,
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: async () => {
        const respuestaDetalles = await FirmarVacante(dataToSend);
        if (respuestaDetalles[0]?.ESTADO === 1) {
          toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAGE);
          getInfo();
        } else {
          toastShow(toast, "error", "Error", respuestaDetalles[0].MENSAGE);
        }
      },
      reject: () => {},
    });
    setSelected([]);
  };

  const changeEstado = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selected.length > 0) {
              changes = selected.map((item) => {
                return {
                  IdVacante: item.IdVacante,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdVacante: data.IdVacante,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Vacantes ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdVacantes = changes.map((item) => item.IdVacante);
                cambiarEstado(e.value.IdStatus, IdVacantes.toString());
                getInfo();
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado = async (IdStatus, IdVacantes) => {
    const result = await chageEstadoVacantes({ IdStatus, IdVacantes });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    setSelected([]);
  };

  const changeEstado2 = ({ data, api }) => {
    return (
      <div>
        <Dropdown
          value={estados2.filter((e) => e.IdStatus === data.IdStatus)[0]}
          options={estados2}
          optionLabel="StatusName"
          filter
          filterBy="StatusName"
          style={{ width: "100%" }}
          onChange={(e) => {
            let changes = [];
            if (selectedDetalles.length > 0) {
              changes = selectedDetalles?.map((item) => {
                return {
                  IdVacanteDetalle: item.IdVacanteDetalle,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                };
              });
            } else {
              changes.push({
                IdVacanteDetalle: data.IdVacanteDetalle,
                IdStatus: e.value.IdStatus,
                StatusName: e.value.StatusName,
              });
            }
            confirmDialog({
              message: `¿Cambiar a estado ${e.value.StatusName} a ${changes.length} Vacantes ?`,
              header: "Confirmación",
              icon: "pi pi-exclamation-triangle",
              accept: async () => {
                let IdVacanteDetalles = changes.map((item) => item.IdVacanteDetalle);
                cambiarEstado2(e.value.IdStatus, IdVacanteDetalles.toString());
                api.stopEditing();
              },
              reject: () => {},
            });
          }}
        />
      </div>
    );
  };

  const cambiarEstado2 = async (IdStatus, IdVacanteDetalles) => {
    const result = await chageEstadoVacantesDetalles({ IdStatus, IdVacanteDetalles });
    toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
    getInfo();
    setSelectedDetalles([]);
  };

  const columns = [
    {
      field: "IdVacante",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "NoVacante",
      headerEn: "No. Vacante",
      header: "No. Vacante",
      frozen: 1,
      className: "small",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      headerEn: "Date Create",
      header: "Fecaha Creado",
      Format: "DateTime",
      frozen: 1,
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado,
      editable: true,
    },
    {
      field: "Posicion",
      headerEn: "Position",
      header: "Posición",
      className: "XXXlarge",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Area",
      headerEn: "Area",
      header: "Area",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "NoPlazas",
      header: "Plazas",
      headerEn: "Places",
      className: "Xsmall",
      Format: "Currency",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Objetivo",
      header: "Objetivo",
      headerEn: "Objective",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Conocimiento",
      header: "Experiencia",
      headerEn: "Expirience",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Educacion",
      header: "Educación",
      headerEn: "Education",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "ComentarioPerfil",
      header: "Otros",
      headerEn: "Others",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "CriteriosContratacion",
      header: "Criterios Contratación",
      headerEn: "Hiring Criteria",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "Reemplazo",
      header: "Reemplazo",
      headerEn: "Replacement",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      filter: false,
      body: (rowData) =>
        rowData?.IdVacante && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox checked={rowData.Reemplazo} />
          </div>
        ),
    },
    {
      field: "Sustitucion",
      header: "Sustitución",
      headerEn: "Substitution",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      filter: false,
      body: (rowData) =>
        rowData?.IdVacante && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox checked={rowData.Sustitucion} />
          </div>
        ),
    },
    {
      field: "NuevaPlaza",
      header: "Nueva Plaza",
      headerEn: "New Place",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      filter: false,
      body: (rowData) =>
        rowData?.IdVacante && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox checked={rowData.NuevaPlaza} />
          </div>
        ),
    },
    {
      field: "EnPresupuesto",
      header: "En Presupuesto",
      headerEn: "In Budget",
      className: "Xsmall",
      Format: "Template",
      align: "center",
      filter: false,
      body: (rowData) =>
        rowData?.IdVacante && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Checkbox checked={rowData.EnPresupuesto} />
          </div>
        ),
    },
    {
      field: "UserNameCreate",
      header: "Usuario Creador",
      headerEn: "User Create",
      className: "small",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacante > 0) {
          setShowDialog(true);
          setSelected([data]);
        }
      },
    },
    idsPermisos.includes(15) ?
    {
       headerName: 'Autorización Ingeniería de Procesos',
       children: [
            {
                field: "UserNameIngenieria",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaIngenieriaStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,
    idsPermisos.includes(16) ?
    {
       headerName: 'Autorización Finanzas',
       children: [
            {
                field: "UserNameFinanzas",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaFinanzasStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,
    idsPermisos.includes(17) ?
    {
       headerName: 'Autorización RRHH',
       children: [
            {
                field: "UserNameRRHH",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaRRHHStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,
    idsPermisos.includes(18) ?
    {
       headerName: 'Autorización Director General',
       children: [
            {
                field: "UserNameDirectorG",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaDirectorGStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,
    idsPermisos.includes(19) ?
    {
       headerName: 'Autorización Director Area',
       children: [
            {
                field: "UserNameDirectorA",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaDirectorAStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,
    idsPermisos.includes(20) ?
    {
       headerName: 'Autorización Gerente Area',
       children: [
            {
                field: "UserNameGerenteA",
                header: "Usuario",
                headerEn: "Usuario",
                className: 'small',
            },
            {
                field: "FechaGerenteAStr",
                header: "Fecha",
                headerEn: "Date",
                Format: "DateTime",
            }
       ]
    } : null,


    {
      headerName: "Autorizaciones",
      hidden:
        firmarIngenieria ||
        firmarFinanzas ||
        firmarRRHH ||
        firmarDirectorGeneral ||
        firmarDirectorArea ||
        firmarGerenteArea,
      children: [
        ...Autorizaciones.map((autorizacion) => {
          // Mapeo de permisos a variables de autorización
          let isEditable = false;

          switch (autorizacion?.IdPermisoGeneral) {
            case 15:
              isEditable = firmarIngenieria;
              break;
            case 16:
              isEditable = firmarFinanzas;
              break;
            case 17:
              isEditable = firmarRRHH;
              break;
            case 18:
              isEditable = firmarDirectorGeneral;
              break;
            case 19:
              isEditable = firmarDirectorArea;
              break;
            case 20:
              isEditable = firmarGerenteArea;
              break;
            default:
              isEditable = false;
          }

          return {
            field: autorizacion?.NombrePermiso,
            header: autorizacion.NombrePermiso,
            frozen: true,
            alignFrozen: "right",
            align: "center",
            className: "Xsmall",
            Format: "Template",
            filter: false,
            body: (rowData) =>
              rowData?.IdVacante && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Checkbox
                    checked={
                      rowData[autorizacion?.NombrePermiso] === 1 ? true : false
                    }
                    disabled={!isEditable}
                    onChange={(event) => {
                      if (selected.length === 0) {
                        agregarFirmas(
                          event,
                          [rowData],
                          autorizacion?.IdPermisoGeneral,
                          autorizacion.NombrePermiso
                        );
                      } else {
                        agregarFirmas(
                          event,
                          selected,
                          autorizacion?.IdPermisoGeneral,
                          autorizacion.NombrePermiso
                        );
                      }
                    }}
                  />
                </div>
              ),
          };
        }),
      ],
    },
    {
      field: "IdVacante",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdVacante > 0) {
              setShowDialog(true);
              setSelected([rowData]);
            }
          },
        },
        {
          icon: "pi pi-plus",
          tooltip: "Agregar Detalle",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdVacante > 0) {
              setShowDialogDetalles(true);
              setSelected([rowData]);
            }
          },
        },
        {
          icon: "pi pi-print",
          tooltip: "Formato",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (selected?.length > 1) {
              toastShow(
                toast,
                "warn",
                "Advertencia",
                "Solo se muestra el formato de una Posición."
              );
            }
            setTimeout(() => {
              if (rowData?.IdVacante > 0) {
                setDialogFormato(true);
                setSelected([rowData]);
              }
            }, 500);
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const handleCheckbox = (e, rowData, field) => {
      let IdVacanteDetalle = rowData?.IdVacanteDetalle;
  
      if (IdVacanteDetalle > 0) {

      } else {
          const nuevosDetalles = detalles.map(detalle => {
              if (detalle === rowData) {
                  return {
                      ...detalle,
                      [field]: e.checked
                  };
              }
              return detalle;
          });
  
          setDetalles(nuevosDetalles);
      }
  };
  
  const columnsDet = [
    {
      field: "IdVacanteDetalle",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      frozen: 1,
    },
    {
      field: "NoVacante",
      headerEn: "Vacante",
      header: "Vacante",
      frozen: 1,
      className: "Xsmall",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        if (data?.IdVacanteDetalle > 0) {
          setShowDialogDetalles(true);
          setSelected([data]);
        }
      },
    },
    {
      field: "DateCreateStr",
      headerEn: "Date Create",
      header: "Fecha Creado",
      Format: "DateTime",
      frozen: 1,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "IdStatus",
      frozen: 1,
      className: "Xsmall",
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      cellEditor: changeEstado2,
      editable: true,
    },
    {
      field: "NombreCompleto",
      headerEn: "Candidato",
      header: "Candidato",
      className: "XXlarge",
    },
    {
      field: "",
      filter: false,
      header: "",
      className: "XXsmall",
      Format: "Template",
      body: (rowData) =>
        rowData.IdAspirante > 0 ? (
          <div style={{display: "flex",justifyContent: "center",alignItems: "center",}}>
            <Button
              icon="pi pi-info-circle"
              className="p-button-text"
              onClick={(e) =>{
                setDialogCandidato(true)
                setAspirante([rowData])
              }}
              tooltip="Información Candidato"
              tooltipOptions={{position: "top"}}
            />
          </div>
        ) : (
        ""
      ),
    },
    {
      field: "Edad",
      headerEn: "Ege",
      header: "Edad",
      className: "Xsmall",
      Format: 'Currency',
    },
    {
      field: "AspiracionSalarial",
      header: "Aspiración Salarial",
      headerEn: "Salary Aspiration",
      className: "Xsmall",
      Format: 'Currency',
    },
    {
      field: "AniosExperiencia",
      header: "Experiencia (Años)",
      headerEn: "Expirience (Years)",
      Format: 'Currency',
      className: "Xsmall",
    },
    {
      field: "GradoAcademico",
      header: "Grado Académico",
      headerEn: "Grado Académico",
      className: "small",
    },
    {
      field: "Posicion",
      headerEn: "Position",
      header: "Posición",
      className: "small",
    },
    {
      headerName: 'Check List para Expediente',
      children: [
        {
          field: "NotificacionIngreso",
          header: "Notificación de Ingreso",
          headerEn: "Admission Notification",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.NotificacionIngreso} onChange={(e) => {handleCheckbox(e, rowData, 'NotificacionIngreso')}}/>
              </div>
            ),
        },
        {
          field: "Entrevista",
          header: "Entrevista",
          headerEn: "Interview",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Entrevista} onChange={(e) => {handleCheckbox(e, rowData, 'Entrevista')}} />
              </div>
            ),
        },
        {
          field: "SolicitudConFoto",
          header: "Solicitud con Foto",
          headerEn: "Application with Photo",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.SolicitudConFoto} onChange={(e) => {handleCheckbox(e, rowData, 'SolicitudConFoto')}} />
              </div>
            ),
        },
        {
          field: "Demografica",
          header: "Ficha Demográfica",
          headerEn: "Demographic Sheet",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Demografica} onChange={(e) => {handleCheckbox(e, rowData, 'Demografica')}} />
              </div>
            ),
        },
        {
          field: "Contrato",
          header: "Contrato",
          headerEn: "Contract",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Contrato} onChange={(e) => {handleCheckbox(e, rowData, 'Contrato')}} />
              </div>
            ),
        },
        {
          field: "EvaluacionLogica",
          header: "Evaluación Lógica",
          headerEn: "Logic Evaluation",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.EvaluacionLogica} onChange={(e) => {handleCheckbox(e, rowData, 'EvaluacionLogica')}} />
              </div>
            ),
        },
        {
          field: "CopiaVacunas",
          header: "Copia de Vacunas",
          headerEn: "Vaccination Record Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaVacunas} onChange={(e) => {handleCheckbox(e, rowData, 'CopiaVacunas')}} />
              </div>
            ),
        },
        {
          field: "EvaluacionMedica",
          header: "Evaluación Médica",
          headerEn: "Medical Evaluation",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.EvaluacionMedica} onChange={(e) => {handleCheckbox(e, rowData, 'EvaluacionMedica')}} />
              </div>
            ),
        },
        {
          field: "Curriculum",
          header: "Currículum",
          headerEn: "Curriculum Vitae",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Curriculum} onChange={(e) => {handleCheckbox(e, rowData, 'Curriculum')}} />
              </div>
            ),
        },
        {
          field: "CopiaDiploma",
          header: "Copia de Diploma",
          headerEn: "Diploma Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaDiploma} onChange={(e) => {handleCheckbox(e, rowData, 'CopiaDiploma')}} />
              </div>
            ),
        },
        {
          field: "AntecedentesPoliciales",
          header: "Ant. Policiales",
          headerEn: "Police Record",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.AntecedentesPoliciales} onChange={(e) => {handleCheckbox(e, rowData, 'AntecedentesPoliciales')}} />
              </div>
            ),
        },
        {
          field: "AntecedentesPenales",
          header: "Ant. Penales",
          headerEn: "Criminal Record",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.AntecedentesPenales} onChange={(e) => {handleCheckbox(e, rowData, 'AntecedentesPenales')}} />
              </div>
            ),
        },
        {
          field: "ConstanciasTrabajo",
          header: "Constancias de Trabajo",
          headerEn: "Employment Letters",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.ConstanciasTrabajo} onChange={(e) => {handleCheckbox(e, rowData, 'ConstanciasTrabajo')}} />
              </div>
            ),
        },
        {
          field: "CartasReferencias",
          header: "Cartas de Referencia",
          headerEn: "Reference Letters",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CartasReferencias} onChange={(e) => {handleCheckbox(e, rowData, 'CartasReferencias')}} />
              </div>
            ),
        },
        {
          field: "Croquis",
          header: "Croquis de Dirección",
          headerEn: "Address Map",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.Croquis} onChange={(e) => {handleCheckbox(e, rowData, 'Croquis')}} />
              </div>
            ),
        },
        {
          field: "CopiaIdentidades",
          header: "Copia de Identidades",
          headerEn: "ID Copies",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaIdentidades} onChange={(e) => {handleCheckbox(e, rowData, 'CopiaIdentidades')}} />
              </div>
            ),
        },
        {
          field: "IdentidadPropia",
          header: "Identidad Original",
          headerEn: "Original ID",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.IdentidadPropia} onChange={(e) => {handleCheckbox(e, rowData, 'IdentidadPropia')}} />
              </div>
            ),
        },
        {
          field: "CopiaRTN",
          header: "Copia de RTN",
          headerEn: "RTN Copy",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.CopiaRTN} onChange={(e) => {handleCheckbox(e, rowData, 'CopiaRTN')}} />
              </div>
            ),
        },
        {
          field: "InformacionAperturaCuentas",
          header: "Info. Apertura Cuenta",
          headerEn: "Bank Account Info",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.InformacionAperturaCuentas} onChange={(e) => {handleCheckbox(e, rowData, 'InformacionAperturaCuentas')}} />
              </div>
            ),
        },
        {
          field: "ManualInduccion",
          header: "Manual de Inducción",
          headerEn: "Induction Manual",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.ManualInduccion} onChange={(e) => {handleCheckbox(e, rowData, 'ManualInduccion')}} />
              </div>
            ),
        },
        {
          field: "InfromacionGeneral",
          header: "Información General",
          headerEn: "General Info",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.InfromacionGeneral} onChange={(e) => {handleCheckbox(e, rowData, 'InfromacionGeneral')}} />
              </div>
            ),
        },
        {
          field: "InduccionFormasPago",
          header: "Inducción de Formas de Pago",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.InduccionFormasPago} onChange={(e) => {handleCheckbox(e, rowData, 'InduccionFormasPago')}} />
              </div>
            ),
        },
        {
          field: "ResenaHistorica",
          header: "Reseña Histrica",
          className: "Xsmall",
          Format: "Template",
          align: "center",
          filter: false,
          body: (rowData) =>
            rowData?.IdVacanteDetalle && (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Checkbox checked={rowData.ResenaHistorica} onChange={(e) => {handleCheckbox(e, rowData, 'ResenaHistorica')}} />
              </div>
            ),
        },
      ]
    },
    {
      field: "PorcentajeCompletado",
      headerEn: "Porcentage",
      header: "Porcentaje",
      Format: 'Porcentaje',
      frozen: 1,
      alignFrozen: "right",
      className: 'Xsmall',
    },
    {
      field: "IdVacanteDetalle",
      header: "",
      Format: "Botones",
      filter: false,
      frozen: 1,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          tooltipOptions: { position: "left" },
          onClick: (rowData) => {
            if (rowData?.IdVacanteDetalle > 0) {
              setShowDialogDetalles(true);
              setSelected([rowData]);
            }
          },
        },
      ],
    },
  ];

  const tableDet = {
    Columns: columnsDet,
    Data: detalles,
    loading: loading,
    selected: selectedDetalles,
    setSelected: setSelectedDetalles,
    showModal: () => {},
  };

  const eliminarDetalles = async () => {
    let IdVacantesDetalle = selectedDetalles.map(i => i?.IdVacanteDetalle).join(',')
    confirmDialog({
      message: "¿Esta seguro que desea eliminar los detalles selecccionados?",
      header: "Eliminar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sí",
      rejectLabel: "No",
      style: { backgroundColor: "white" },
      accept: async () => {
        setLoading(true)
        const resp = await EliminarVacanteDetalles(IdVacantesDetalle)
        toastShow(toast, 'success', 'Eliminado', 'Detalle eliminado correctamente.')
        getInfo()
        setLoading(false)
      },
      reject: () => {},
    });
  }

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "Vacantes", config.language));
    getInfo();
  }, []);

  return (
    <div>
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="d-flex gap-2">
            <Button icon="pi pi-refresh" onClick={getInfo} />
            {activeIndex === 0 && (
              <Button
                icon="pi pi-plus"
                severity="success"
                onClick={() => {
                  setShowDialog(true);
                  setSelected([]);
                }}
              />
            )}
            {activeIndex === 1 && (
              <Button icon="pi pi-times" className="p-button-danger" onClick={eliminarDetalles} disabled={selectedDetalles.length === 0}/>
            )}
          </div>
        }
        contenido={
          <div className="mt-4">
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header={getLabel(baseLang, "Vacantes", config.language)}>
                <div style={{height: '78vh'}}>
                  <AgGrid table={table} />
                </div>
              </TabPanel>

              <TabPanel header="Detalles">
                <div style={{height: '78vh'}}>
                  <AgGrid table={tableDet} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      {showDialog && (
        <VacantesCRUD
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
          modo={selected?.length > 0 ? "Editar" : "Crear"}
        />
      )}

      {showDialogDetalles && (
        <DetallesVacantesCRUD
          showDialogDetalles={showDialogDetalles}
          setShowDialogDetalles={setShowDialogDetalles}
          getInfo={getInfo}
          selected={selected}
          setSelected={setSelected}
        />
      )}

      {dialogFormato && (
        <FormatoVacante
          dialogFormato={dialogFormato}
          setDialogFormato={setDialogFormato}
          selected={selected}
          setSelected={setSelected}
        />
      )}

      {dialogCandidato && (
        <CandidatosCRUD
          showDialog={dialogCandidato}
          setShowDialog={setDialogCandidato}
          getInfo={()=>{}}
          selected={aspirante}
          setSelected={setAspirante}
          modo={aspirante?.length > 0  ? "Editar" : "Crear"}
          editable={false}
        />
      )}

    </div>
  );
};

export default VacantesScreen;
